import { createApp } from 'vue'
import App from '@trust/App.vue'
import store from '@trust/store'
import router from '@trust/router'
import { VueCookieNext } from 'vue-cookie-next'
import * as FullStory from '@fullstory/browser';

FullStory.init({ orgId: '18E3XA' });

const app = createApp(App)
app.use(VueCookieNext)
app.use(router)
app.use(store)
app.config.globalProperties.$FullStory = FullStory;
router.store = store
router.VueCookieNext = VueCookieNext
app.mount('#app')

// set default cookie config
let domain = window.location.hostname;
console.log('domain for cookie: ', domain);
VueCookieNext.config({
  expire: '40d',
  secure: true,
  sameSite: 'Lax', // ???
  domain: domain
})
